import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import { AuthProvider } from "@/lib/auth";
import { ProtectedAdminRoute } from "@/components/providers/protected-admin-route";
import { AdminLayout } from "@/components/AdminLayout";

import { AdminOrdersPage } from "@/routes/AdminOrdersPage";
import { AdminOrderDetailPage } from "@/routes/AdminOrderDetailPage";
import { AdminSupportPage } from "@/routes/AdminSupportPage";
import { AdminQaPage } from "@/routes/AdminQaPage";
import { AdminQaSessionPage } from "@/routes/AdminQaSessionPage";
import { AdminSignInPage } from "@/routes/AdminSignInPage";

export function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Routes>
          <Route path="/admin/signin" element={<AdminSignInPage />} />
          <Route
            element={
              <ProtectedAdminRoute>
                <AdminLayout />
              </ProtectedAdminRoute>
            }
          >
            <Route path="/admin" element={<AdminOrdersPage />} />
            <Route path="/admin/orders/:orderId" element={<AdminOrderDetailPage />} />
            <Route path="/admin/support" element={<AdminSupportPage />} />
            <Route path="/admin/qa" element={<AdminQaPage />} />
            <Route path="/admin/qa/:sessionId" element={<AdminQaSessionPage />} />
            {/* Fallback: anything under /admin/* redirects to /admin */}
            <Route path="/admin/*" element={<Navigate to="/admin" replace />} />
          </Route>
          {/* Root redirect */}
          <Route path="*" element={<Navigate to="/admin" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}
